import { FC } from 'react';
import { useSelector } from 'react-redux';

import { withRouter, RouteComponentProps, useHistory } from 'react-router-dom';
import { RootState } from 'store/rootReducer';
import MainRoute from './main.route';
import LoginRoute from './login.route';
import MonitoringRoute from './monitoring.route';
import useDomain from '../hooks/useDomain';

const RootRouter: FC<RouteComponentProps> = () => {
  useDomain();
  const { user } = useSelector((state: RootState) => state.authState);
  const history = useHistory();

  return user ? history.location.pathname === '/monitoring' ? <MonitoringRoute/> : <MainRoute /> : <LoginRoute />;
};

export default withRouter(RootRouter);
